import { RESET_PASSWORD_STORE_TOKEN, RESET_PASSWORD_TOKEN_INVALIDATED } from '../actions/passwordResets';

const passwordResets = (state = null, action = undefined) => {
    switch (action.type) {
        case RESET_PASSWORD_STORE_TOKEN:
            return action.payload.token;
        case RESET_PASSWORD_TOKEN_INVALIDATED:
            return null;
        default:
            return state;
    }
};

export default passwordResets;
